import tw, { styled } from 'twin.macro';
import { useTranslation } from 'next-i18next';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { useIntercom } from 'react-use-intercom';

import { ButtonV2 } from '@restworld/ui-ds';

function DashboardTalkWithUsCard() {
  const { t } = useTranslation('dashboard-page');
  const { showMessages } = useIntercom();

  const handleClick = () => {
    showMessages();
  };

  return (
    <CardContainer>
      <TextWrapper>
        <CardTitle>{t('need_support')}</CardTitle>
        <CardSubtitle>{t('write_to_us_in_chat')}</CardSubtitle>
      </TextWrapper>
      <ButtonV2 variant="tertiary" size="sm" StartIcon={ChatBubbleLeftRightIcon} fullwidth onClick={handleClick}>
        {t('open_chat')}
      </ButtonV2>
    </CardContainer>
  );
}

export default DashboardTalkWithUsCard;

const CardContainer = styled.div`
  ${tw`flex flex-col gap-4 rounded-2xl bg-neutral-10 p-4 pt-5 border border-neutral-40 shadow-[0px_2px_4px_0px_rgba(0,0,26,0.05)]`}
`;
const TextWrapper = styled.div`
  ${tw`flex flex-col gap-1`}
`;
const CardTitle = styled.span`
  ${tw`text-sm font-semibold text-neutral-700`}
`;
const CardSubtitle = styled.span`
  ${tw`text-sm font-normal text-neutral-100`}
`;
